<template>
  <div class="relative w-full h-screen-minus-80 flex items-center justify-left overflow-x-auto">
    <div class="w-[360px] h-full relative">
      <div @scroll="onScroll" ref="refScroll"
        class="flex border flex-col sticky items-left h-screen-minus-80 bg-white overflow-y-auto custom-scrollbar scrollbar-x">
        <div class="my-10 flex justify-center" v-if="!fileModel">
          <div :class="{ 'opacity-0': !isMove }">
            <NuxtImg class="absolute cursor-pointer rounded-full" src="/assets/images/functype/AIPortrait/upload.webp"
              width="112" height="112" alt="upload" loading="lazy">
            </NuxtImg>
          </div>
          <div :class="{ 'opacity-0': isMove }">
            <NuxtImg class="cursor-pointer rounded-full" src="/assets/images/functype/AIPortrait/upload-hover.webp"
              width="112" height="112" alt="upload" loading="lazy"></NuxtImg>
          </div>
        </div>
        <div class="my-10 flex justify-center" v-else>
          <div class="border rounded-full border-gray-line" v-if="props.fileList[0].localUrl">
            <NuxtImg class="cursor-pointer rounded-full object-cover w-[112px] h-[112px] "
              :src="props.fileList[0].localUrl" width="112" height="112" alt="upload" loading="lazy"></NuxtImg>
          </div>
          <div v-if="isShow" style="background-color: #00000066;"
            class="absolute w-fit px-2 py-1 rounded-lg flex items-center top-[100px] left-1/2 -translate-x-1/2 -translate-y-1/2">
            <img class="w-4 h-4" src="/assets/images/functype/AIGenerator/ReSelect.png" alt="">
            <div class="ml-1 Roboto-10 text-white">{{ $t("enhance-AI-Re-select") }}</div>
          </div>
        </div>
        <div @mousemove="isShow = true, isMove = false" @mouseleave="isShow = false, isMove = true"
          class="absolute top-10 left-1/3 h-[112px] w-[112px] opacity-0 z-[2] overflow-hidden"
          :class="{ 'pointer-events-none': (fileModel?.status == uploadStatus?.handle || fileModel?.status == uploadStatus?.lodingImg) && !fileModel?.enhanceUrl }">
          <FuncTypeUpload :funcType="route.params.funcType">
          </FuncTypeUpload>
        </div>
        <div class="mb-6">
          <span class="Roboto-Bold-14 ml-3">
            {{ $t('Gender') }} </span>
          <div class="mt-4 flex justify-center ml-1">
            <div class="cursor-pointer w-[96px] h-[86px] mx-2 rounded-[20px]" v-for="(item, index) in genderList"
              :key="index" :value="index"
              :class="{ 'selected': selectedImageIndex === index, 'border bg-light-gray-bg hover:bg-[#5F45FF14]': selectedImageIndex != index }"
              @click="onClickImg(index)">
              <div class="flex flex-col items-center justify-center mt-1">
                <img class="rounded-3xl border h-[48px] w-[48px] mb-2" :src="item.src" alt="AI Matching Image">
                <span class="Roboto-Bold-12">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-5" :class="{ 'sticky-header': isScroll }">
          <span class="Roboto-Bold-14 ml-3">
            {{ $t('enhance-style') }}
          </span>
          <div class="mt-4 flex flex-wrap mx-2 ">
            <div v-for="(item, index) in styleList" :key="item.key" :value="item.key" class=" cursor-pointer border rounded-3xl h-[36px] px-2 mx-1 mb-4 flex items-center justify-center
              flex-grow max-w-[200px]"
              :class="{ 'text-mainColor-deep bg-[#5F45FF14] border border-[#5F45FF66]': selectedStyleIndex === index, 'text-black bg-[#F7F7F8] hover:bg-gray-line': selectedStyleIndex != index }"
              style="flex-basis: calc(25% - 16px);" @click="onClickStyle(index)">
              <div class="Roboto-Bold-12 whitespace-nowrap px-[8px]">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 mb-[120px] flex items-center justify-center">
          <div class="grid grid-cols-3">
            <div :id="'img-' + item.key" v-for="(item, index) in imgList" :value="item.key" :key="item.key" class="m-2"
              @click="onClickStyleImage(item, index)">
              <div :class="{ 'imgSelected': selectedStyleImageIndex === index }">
                <NuxtImg :src="item.src" loading="lazy" :alt="item.style" width="92" height="138"
                  :modifiers="{ refresh: true, cache: true, format: 'webp' }" class="rounded-lg cursor-pointer"
                  @error="handleImageError(item, $event)">
                </NuxtImg>
              </div>
            </div>
          </div>
        </div>
        <div style="background-color: rgba(255 255 255 / 94%)" class="h-[88px] w-[339px] p-5 bottom-0 left-0 fixed"
          :class="{ 'pointer-events-none': fileModel?.status == uploadStatus?.handle || fileModel?.status == uploadStatus?.lodingImg && !fileModel?.enhanceUrl }">
          <EnhanceGenerate @click="onApply" :enable="applyEnabled" :picNum="1">
          </EnhanceGenerate>
        </div>
      </div>
    </div>
    <div class="relative h-[90%] flex-1 flex items-center justify-center m-[32px] ">
      <div class="relative max-w-[1200px] w-full h-full  flex items-center justify-center rounded-xl"
        :class="{ 'bg-white shadow-1': fileModel?.enhanceUrl }">
        <div class="rounded-xl w-full h-full">
          <div v-if="
            (fileModel?.status == uploadStatus?.handle ||
              fileModel?.status == uploadStatus?.lodingImg) && !fileModel?.enhanceUrl
          ">
            <EnhancePreLoadPortrait class="absolute left-0 bottom-0" ref="preLoadRef" :fileModel="fileModel">
            </EnhancePreLoadPortrait>
          </div>
          <div v-if="!fileModel?.enhanceUrl" class="w-full h-full">
            <div v-if="!isLoaded" class="loading-overlay">
              <div class="loading-spinner"></div>
            </div>
            <div ref="bgContainer" class="h-full w-full bg-no-repeat bg-contain bg-center"
              :style="`background-image: url(${selectSrc})`">
            </div>
          </div>
          <div class="w-full h-full relative" v-else>
            <EnhanceImageView ref="imageViewRef" :minScale="minScale" :maxScale="maxScale" :url="fileModel?.enhanceUrl">
            </EnhanceImageView>
            <EnhanceGiveALike class="absolute right-4 bottom-4" v-if="isLogin" v-show="fileModel?.enhanceUrl &&
              !fileModel.isEvaluate
              " :id="fileModel.enhanceRecordId" @onEvaluate="onEvaluate">
            </EnhanceGiveALike>
          </div>
        </div>
      </div>
    </div>
    <BaseModal :title="$t('modal-switch-title')" :content="$t('modal-portrait-text')" :visible="funcVisible"
      @close="switchHandleCancel">
      <div class="flex items-stretch text-center justify-center items-center">
        <span
          class="w-full bg-gray-line py-3 px-6 cursor-pointer rounded-full text-black mr-3 flex items-center justify-center Roboto-Bold-14"
          @click="switchHandleCancel">
          {{ $t("cancel") }}
        </span>
        <span
          class="w-full bg-mainColor-deep py-3 px-6 cursor-pointer rounded-full text-white flex items-center justify-center Roboto-Bold-14"
          @click="switchHandleOk">
          {{ $t("modal-png-ok") }}
        </span>
      </div>
    </BaseModal>
  </div>
</template>
<script setup>
import { useMainStore } from "@/store/index";
const props = defineProps({
  fileList: {
    type: Array,
    default: [],
  },
  applyEnabled: {
    type: Boolean,
    default: false,
  }
});
const route = useRoute();
const { t } = useI18n();
const isMove = ref(true)
const isShow = ref(false)
const mainStore = useMainStore();
const selectedStyleIndex = ref(0)
const selectedImageIndex = ref(0)
const selectedStyleImageIndex = ref(0)
const { isLogin, isVip, isVipPro } = useUserInfo();
const { applyEvent, updateFileListEvent, downloadUrlEvent } = useCustomEvent();
const genderList = ref([
  { key: 0, name: t('Female'), src: '/assets/images/functype/AIPortrait/female.webp' },
  { key: 1, name: t('male'), src: '/assets/images/functype/AIPortrait/male.webp' },
  { key: 2, name: t('blog-all'), src: '/assets/images/functype/AIPortrait/all.webp' }
])
const styleList = ref([
  { key: 0, name: t('Artistic'), src: '/assets/images/functype/AIPortrait/all.webp' },
  { key: 1, name: t('funcType-enhance-demo-1'), src: '/assets/images/functype/AIPortrait/female.webp' },
  { key: 2, name: t('Stylized'), src: '/assets/images/functype/AIPortrait/male.webp' },
  { key: 3, name: t('Figure'), src: '/assets/images/functype/AIPortrait/all.webp' }
])

// Portrait女生
const imgListPortraitFemale = ref([
  // 女生 敦煌
  { gender: 1, key: 0, api: 79, style: 2, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-female-dhsh1.webp" },
  { gender: 1, key: 1, api: 79, style: 2, value: 3, src: "/assets/images/functype/AIPortrait/Portrait-female-dhsh2.webp" },
  { gender: 1, key: 2, api: 79, style: 2, value: 4, src: "/assets/images/functype/AIPortrait/Portrait-female-dhsh3.webp" },
  // 女生 桂林山水
  { gender: 1, key: 3, api: 79, style: 5, value: 3, src: "/assets/images/functype/AIPortrait/Portrait-female-glss1.webp" },
  { gender: 1, key: 4, api: 79, style: 5, value: 2, src: "/assets/images/functype/AIPortrait/Portrait-female-glss2.webp" },
  // 女生 宫廷风
  { gender: 1, key: 5, api: 79, style: 1, value: 5, src: "/assets/images/functype/AIPortrait/Portrait-female-gtf1.webp" },
  { gender: 1, key: 6, api: 79, style: 1, value: 14, src: "/assets/images/functype/AIPortrait/Portrait-female-gtf2.webp" },
  { gender: 1, key: 7, api: 79, style: 1, value: 9, src: "/assets/images/functype/AIPortrait/Portrait-female-gtf3.webp" },
  // 女生 惠安女
  { gender: 1, key: 8, api: 79, style: 31, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-han1.webp" },
  { gender: 1, key: 9, api: 79, style: 31, value: 3, src: "/assets/images/functype/AIPortrait/Portrait-female-han2.webp" },
  // 女生 汉服
  { gender: 1, key: 10, api: 79, style: 0, value: 5, src: "/assets/images/functype/AIPortrait/Portrait-female-hf.webp" },
  { gender: 1, key: 11, api: 79, style: 0, value: 8, src: "/assets/images/functype/AIPortrait/Portrait-female-hf1.webp" },
  { gender: 1, key: 12, api: 79, style: 0, value: 3, src: "/assets/images/functype/AIPortrait/Portrait-female-hf2.webp" },
  { gender: 1, key: 13, api: 79, style: 0, value: 7, src: "/assets/images/functype/AIPortrait/Portrait-female-hf3.webp" },
  // 女生 林薇因
  { gender: 1, key: 14, api: 79, style: 32, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-lwy1.webp" },
  { gender: 1, key: 15, api: 79, style: 32, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-female-lwy2.webp" },
  // 女生 湄洲女
  { gender: 1, key: 16, api: 79, style: 33, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-female-mzn1.webp" },
  { gender: 1, key: 17, api: 79, style: 33, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-mzn2.webp" },
  // 女生 泉州簪花
  { gender: 1, key: 18, api: 79, style: 80, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-female-qzzh1.webp" },
  { gender: 1, key: 19, api: 79, style: 80, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-qzzh2.webp" },
  // 女生 苏式旗袍
  { gender: 1, key: 20, api: 79, style: 81, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-female-ssqp1.webp" },
  { gender: 1, key: 21, api: 79, style: 81, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-ssqp2.webp" },
  // 女生 三条簪
  { gender: 1, key: 22, api: 79, style: 34, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-stz1.webp" },
  { gender: 1, key: 23, api: 79, style: 34, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-female-stz2.webp" },
  // 女生 畲族服饰
  { gender: 1, key: 24, api: 79, style: 35, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-szfs1.webp" },
  { gender: 1, key: 25, api: 79, style: 35, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-female-szfs2.webp" },
  // 女生 新疆服饰
  { gender: 1, key: 26, api: 79, style: 3, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-female-xjfs1.webp" },
  { gender: 1, key: 27, api: 79, style: 3, value: 3, src: "/assets/images/functype/AIPortrait/Portrait-female-xjfs2.webp" }
])

// Portrait 男生
const imgListPortraitMan = ref([
  // 男生宫廷风
  { gender: 0, key: 28, api: 79, style: 10, value: 7, src: "/assets/images/functype/AIPortrait/Portrait-man-gtf1.webp" },
  { gender: 0, key: 29, api: 79, style: 10, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-man-gtf2.webp" },
  { gender: 0, key: 30, api: 79, style: 10, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-man-gtf3.webp" },
  // 将乐·玉华洞
  { gender: 0, key: 31, api: 79, style: 75, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-man-jlyhd.webp" },
  // 男生丽江古城
  { gender: 0, key: 32, api: 79, style: 8, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-man-ljgc1.webp" },
  { gender: 0, key: 33, api: 79, style: 8, value: 2, src: "/assets/images/functype/AIPortrait/Portrait-man-ljgc2.webp" },
  // 男生 民国风
  { gender: 0, key: 34, api: 79, style: 39, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-man-mgf1.webp" },
  { gender: 0, key: 35, api: 79, style: 39, value: 1, src: "/assets/images/functype/AIPortrait/Portrait-man-mgf2.webp" },
  { gender: 0, key: 36, api: 79, style: 39, value: 2, src: "/assets/images/functype/AIPortrait/Portrait-man-mgf3.webp" },
  // 男生 泉州簪花
  { gender: 0, key: 37, api: 79, style: 73, value: 0, src: "/assets/images/functype/AIPortrait/Portrait-man-qzzh.webp" }
])

// Stylized 男生

const imgListStylizedMan = ref([
  { gender: 0, key: 38, api: 76, style: 'Clay', value: 'Clay', src: "/assets/images/functype/AIPortrait/Stylized-man-clay.webp" },
  { gender: 0, key: 39, api: 76, style: 'Enix', value: 'KingdomHearts', src: "/assets/images/functype/AIPortrait/Stylized-man-enix.webp" },
  { gender: 0, key: 40, api: 76, style: 'Yellow Being', value: 'Simpsons', src: "/assets/images/functype/AIPortrait/Stylized-man-yellow_being.webp" },
  { gender: 0, key: 41, api: 76, style: 'Bricks', value: 'Lego', src: "/assets/images/functype/AIPortrait/Stylized-man-bricks.webp" },
  { gender: 0, key: 42, api: 76, style: 'Gal', value: 'Tsukihime', src: "/assets/images/functype/AIPortrait/Stylized-man-gal.webp" },
  { gender: 0, key: 43, api: 76, style: '3D Render', value: '3DRender', src: "/assets/images/functype/AIPortrait/Stylized-man-3d_render.webp" },
  { gender: 0, key: 44, api: 76, style: 'Digital', value: 'VectorIllustration', src: "/assets/images/functype/AIPortrait/Stylized-man-digital.webp" },
  { gender: 0, key: 45, api: 76, style: 'Doll', value: 'Babi', src: "/assets/images/functype/AIPortrait/Stylized-man-doll.webp" },
  { gender: 0, key: 46, api: 76, style: 'Retro', value: 'Pixel', src: "/assets/images/functype/AIPortrait/Stylized-man-retro.webp" },
  { gender: 0, key: 47, api: 76, style: 'Woolfelt', value: 'WoolFelt', src: "/assets/images/functype/AIPortrait/Stylized-man-woolfelt.webp" },
  { gender: 0, key: 48, api: 76, style: 'Jade', value: 'Jade', src: "/assets/images/functype/AIPortrait/Stylized-man-jade.webp" },
  { gender: 0, key: 49, api: 76, style: 'Arcane', value: 'Arcane', src: "/assets/images/functype/AIPortrait/Stylized-man-arcane.webp" },
  { gender: 0, key: 50, api: 76, style: 'Repin', value: 'Disco', src: "/assets/images/functype/AIPortrait/Stylized-man-repin.webp" },
  { gender: 0, key: 51, api: 76, style: 'Bizarre World', value: 'JOJO', src: "/assets/images/functype/AIPortrait/Stylized-man-bizarre_world.webp" },
  { gender: 0, key: 52, api: 76, style: 'OVA', value: 'OldComics', src: "/assets/images/functype/AIPortrait/Stylized-man-ova.webp" },
  { gender: 0, key: 53, api: 76, style: 'Manga', value: 'Qcartoon', src: "/assets/images/functype/AIPortrait/Stylized-man-manga.webp" },
  { gender: 0, key: 54, api: 76, style: 'Anime', value: 'Ghibli', src: "/assets/images/functype/AIPortrait/Stylized-man-anime.webp" },
  { gender: 0, key: 55, api: 76, style: 'Dive', value: 'Underwater', src: "/assets/images/functype/AIPortrait/Stylized-man-dive.webp" },
  { gender: 0, key: 56, api: 76, style: 'Comic', value: 'Comiclo', src: "/assets/images/functype/AIPortrait/Stylized-man-comic.webp" },
  { gender: 0, key: 57, api: 76, style: 'Phantom', value: 'Catherine', src: "/assets/images/functype/AIPortrait/Stylized-man-phantom.webp" },
  { gender: 0, key: 58, api: 76, style: 'illustration', value: 'TextureIllustration', src: "/assets/images/functype/AIPortrait/Stylized-man-illustration.webp" },
  { gender: 0, key: 59, api: 76, style: 'Ink', value: 'InkGold', src: "/assets/images/functype/AIPortrait/Stylized-man-ink.webp" },
  { gender: 0, key: 60, api: 76, style: 'Colored Pencil', value: 'ColoredPencil', src: "/assets/images/functype/AIPortrait/Stylized-man-colored_pencil.webp" },
  { gender: 0, key: 61, api: 76, style: 'Drawing', value: 'Suzuki', src: "/assets/images/functype/AIPortrait/Stylized-man-drawing.webp" }

])
// Stylized 女生
const imgListStylizedFemale = ref([
  { gender: 1, key: 62, api: 76, style: 'Clay', value: 'Clay', src: "/assets/images/functype/AIPortrait/Stylized-female-clay.webp" },
  { gender: 1, key: 63, api: 76, style: 'Enix', value: 'KingdomHearts', src: "/assets/images/functype/AIPortrait/Stylized-female-enix.webp" },
  { gender: 1, key: 64, api: 76, style: 'Yellow Being', value: 'Simpsons', src: "/assets/images/functype/AIPortrait/Stylized-female-yellow_being.webp" },
  { gender: 1, key: 65, api: 76, style: 'Bricks', value: 'Lego', src: "/assets/images/functype/AIPortrait/Stylized-female-bricks.webp" },
  { gender: 1, key: 66, api: 76, style: 'Gal', value: 'Tsukihime', src: "/assets/images/functype/AIPortrait/Stylized-female-gal.webp" },
  { gender: 1, key: 67, api: 76, style: '3D Render', value: '3DRender', src: "/assets/images/functype/AIPortrait/Stylized-female-3d_render.webp" },
  { gender: 1, key: 68, api: 76, style: 'Digital', value: 'VectorIllustration', src: "/assets/images/functype/AIPortrait/Stylized-female-digital.webp" },
  { gender: 1, key: 69, api: 76, style: 'Doll', value: 'Babi', src: "/assets/images/functype/AIPortrait/Stylized-female-doll.webp" },
  { gender: 1, key: 70, api: 76, style: 'Retro', value: 'Pixel', src: "/assets/images/functype/AIPortrait/Stylized-female-retro.webp" },
  { gender: 1, key: 71, api: 76, style: 'Woolfelt', value: 'WoolFelt', src: "/assets/images/functype/AIPortrait/Stylized-female-woolfelt.webp" },
  { gender: 1, key: 72, api: 76, style: 'Jade', value: 'Jade', src: "/assets/images/functype/AIPortrait/Stylized-female-jade.webp" },
  { gender: 1, key: 73, api: 76, style: 'Arcane', value: 'Arcane', src: "/assets/images/functype/AIPortrait/Stylized-female-arcane.webp" },
  { gender: 1, key: 74, api: 76, style: 'Repin', value: 'Disco', src: "/assets/images/functype/AIPortrait/Stylized-female-repin.webp" },
  { gender: 1, key: 75, api: 76, style: 'Bizarre World', value: 'JOJO', src: "/assets/images/functype/AIPortrait/Stylized-female-bizarre_world.webp" },
  { gender: 1, key: 76, api: 76, style: 'OVA', value: 'OldComics', src: "/assets/images/functype/AIPortrait/Stylized-female-ova.webp" },
  { gender: 1, key: 77, api: 76, style: 'Manga', value: 'Qcartoon', src: "/assets/images/functype/AIPortrait/Stylized-female-manga.webp" },
  { gender: 1, key: 78, api: 76, style: 'Anime', value: 'Ghibli', src: "/assets/images/functype/AIPortrait/Stylized-female-anime.webp" },
  { gender: 1, key: 79, api: 76, style: 'Dive', value: 'Underwater', src: "/assets/images/functype/AIPortrait/Stylized-female-dive.webp" },
  { gender: 1, key: 80, api: 76, style: 'Comic', value: 'Comiclo', src: "/assets/images/functype/AIPortrait/Stylized-female-comic.webp" },
  { gender: 1, key: 81, api: 76, style: 'Phantom', value: 'Catherine', src: "/assets/images/functype/AIPortrait/Stylized-female-phantom.webp" },
  { gender: 1, key: 82, api: 76, style: 'illustration', value: 'TextureIllustration', src: "/assets/images/functype/AIPortrait/Stylized-female-illustration.webp" },
  { gender: 1, key: 83, api: 76, style: 'Ink', value: 'InkGold', src: "/assets/images/functype/AIPortrait/Stylized-female-ink.webp" },
  { gender: 1, key: 84, api: 76, style: 'Colored Pencil', value: 'ColoredPencil', src: "/assets/images/functype/AIPortrait/Stylized-female-colored_pencil.webp" },
  { gender: 1, key: 85, api: 76, style: 'Drawing', value: 'Suzuki', src: "/assets/images/functype/AIPortrait/Stylized-female-drawing.webp" }
])

// Artistic 女生
const imgListArtisticFemale = ref([
  { gender: 1, key: 86, api: 77, style: '39-rococo', value: 'rococo_woman7', src: "/assets/images/functype/AIPortrait/Artistic-rococo-1.webp" },
  { gender: 1, key: 87, api: 77, style: '39-rococo', value: 'rococo_woman10', src: "/assets/images/functype/AIPortrait/Artistic-rococo-2.webp" },
  { gender: 1, key: 88, api: 77, style: '39-rococo', value: 'rococo_woman4', src: "/assets/images/functype/AIPortrait/Artistic-rococo-3.webp" },
  { gender: 1, key: 89, api: 77, style: '39-rococo', value: 'rococo_woman8', src: "/assets/images/functype/AIPortrait/Artistic-rococo-4.webp" },
  { gender: 1, key: 90, api: 77, style: '5-Christmas-petlover', value: 'Petlover_panda4', src: "/assets/images/functype/AIPortrait/Artistic-zoo-1.webp" },
  { gender: 1, key: 91, api: 77, style: '5-Christmas-petlover', value: 'Petlover_horse1', src: "/assets/images/functype/AIPortrait/Artistic-zoo-2.webp" },
  { gender: 1, key: 92, api: 77, style: '5-Christmas-petlover', value: 'Petlover_deer2', src: "/assets/images/functype/AIPortrait/Artistic-zoo-3.webp" },
  { gender: 1, key: 93, api: 77, style: '5-Christmas-petlover', value: 'Petlover_capybara3', src: "/assets/images/functype/AIPortrait/Artistic-zoo-4.webp" },
  { gender: 1, key: 94, api: 77, style: '14-Dating', value: 'dating11', src: "/assets/images/functype/AIPortrait/Artistic-lifestyle-1.webp" },
  { gender: 1, key: 95, api: 77, style: '14-Dating', value: 'dating15', src: "/assets/images/functype/AIPortrait/Artistic-lifestyle-2.webp" },
  { gender: 1, key: 96, api: 77, style: '14-Dating', value: 'dating12', src: "/assets/images/functype/AIPortrait/Artistic-lifestyle-3.webp" },
  { gender: 1, key: 97, api: 77, style: '11-Pregnancy', value: 'pregnant2', src: "/assets/images/functype/AIPortrait/Artistic-maternity-1.webp" },
  { gender: 1, key: 98, api: 77, style: '11-Pregnancy', value: 'pregnant1', src: "/assets/images/functype/AIPortrait/Artistic-maternity-2.webp" },
  { gender: 1, key: 99, api: 77, style: '3-Christmas-Fairytale', value: 'Fairytale_desert', src: "/assets/images/functype/AIPortrait/Artistic-goddess-1.webp" },
  { gender: 1, key: 100, api: 77, style: '3-Christmas-Fairytale', value: 'Fairytale_forest', src: "/assets/images/functype/AIPortrait/Artistic-goddess-2.webp" },
  { gender: 1, key: 101, api: 77, style: '3-Christmas-Fairytale', value: 'Fairytale_sky', src: "/assets/images/functype/AIPortrait/Artistic-goddess-3.webp" },
  { gender: 1, key: 102, api: 77, style: '3-Christmas-Fairytale', value: 'Fairytale_original', src: "/assets/images/functype/AIPortrait/Artistic-goddess-4.webp" },
  { gender: 1, key: 103, api: 77, style: '12-80s-Japanese', value: '80s Japanese2', src: "/assets/images/functype/AIPortrait/Artistic-japan-1.webp" },
  { gender: 1, key: 104, api: 77, style: '12-80s-Japanese', value: '80s Japanese4', src: "/assets/images/functype/AIPortrait/Artistic-japan-2.webp" },
  { gender: 1, key: 105, api: 77, style: '12-80s-Japanese', value: '80s Japanese1', src: "/assets/images/functype/AIPortrait/Artistic-japan-3.webp" },
  { gender: 1, key: 106, api: 77, style: '12-80s-Japanese', value: '80s Japanese7', src: "/assets/images/functype/AIPortrait/Artistic-japan-4.webp" },
  { gender: 1, key: 107, api: 78, style: 120, value: 0, src: "/assets/images/functype/AIPortrait/Artistic-survivalfemale.webp" }
])

// Artistic 男生
const imgListArtisticMan = ref([
  { gender: 0, key: 108, api: 77, style: '4-Christmas-Gentleman', value: 'gentleman3', src: "/assets/images/functype/AIPortrait/Artistic-gentleman.webp" },
  { gender: 0, key: 109, api: 80, style: 2, value: 0, src: "/assets/images/functype/AIPortrait/Artistic-aimuscle.webp" },
  { gender: 0, key: 110, api: 77, style: '17-Egypt', value: 'Egypt2', src: "/assets/images/functype/AIPortrait/Artistic-egypt.webp" },
  { gender: 0, key: 111, api: 77, style: '9-1940-Vintage', value: '1930 vintage 11', src: "/assets/images/functype/AIPortrait/Artistic-1940s.webp" },
  { gender: 0, key: 112, api: 78, style: 119, value: 0, src: "/assets/images/functype/AIPortrait/Artistic-survivalman.webp" },
  { gender: 0, key: 113, api: 77, style: '6-LinkedIn', value: 'man2', src: "/assets/images/functype/AIPortrait/Artistic-headshot.webp" }
])

// Figure 男生
const imgListFigure = ref([
  { gender: 0, key: 114, api: 76, style: 'Duo Nendo', value: 'SingleDoubleQ', src: "/assets/images/functype/AIPortrait/Figure-duonendo.webp" },
  { gender: 0, key: 115, api: 81, style: 'Mini Toy', value: 'minitoy', src: "/assets/images/functype/AIPortrait/Figure-minitoy.webp" },
  { gender: 0, key: 116, api: 76, style: 'NendoQ', value: 'Blindbox', src: "/assets/images/functype/AIPortrait/Figure-nendoq.webp" },
  { gender: 0, key: 117, api: 76, style: 'Real Figure', value: 'Real', src: "/assets/images/functype/AIPortrait/Figure-realfigure.webp" }
])

const imgList = ref([])
const genders = ref(0)
const selectSrc = ref('')
const fileModel = ref(null);
const selectParams = ref({
  enhanceCfgIds: [79],
  stylePath: 2
});
const bgContainer = ref(null)
const typeModal = ref(null)
const indexs = ref(null)
const indexs2 = ref(null)
const indexs3 = ref(null)
const onClickImg = (index) => {
  if ((fileModel.value?.status == uploadStatus?.handle || fileModel.value?.status == uploadStatus?.lodingImg) && !fileModel.value?.enhanceUrl) {
    return;
  }
  if (isGo.value) {
    selectedImageIndex.value = index;
  } else {
    indexs.value = index
  }
  if (fileModel.value?.enhanceUrl && !isGo.value) {
    typeModal.value = 1
    funcVisible.value = true;
    return;
  }
  selectedImageIndex.value = index;
  selectedStyleImageIndex.value = 0;
  genders.value = index;
  getStyleImageList()
  onClickStyleImage(imgList.value[selectedStyleImageIndex.value], selectedStyleImageIndex.value)
}
const onClickStyle = (index) => {
  if ((fileModel.value?.status == uploadStatus?.handle || fileModel.value?.status == uploadStatus?.lodingImg) && !fileModel.value?.enhanceUrl) {
    return;
  }
  if (isGo.value) {
    selectedStyleIndex.value = index;
  } else {
    indexs2.value = index
  }
  if (fileModel.value?.enhanceUrl && !isGo.value) {
    funcVisible.value = true;
    typeModal.value = 2
    return;
  }
  selectedStyleIndex.value = index;
  selectedStyleImageIndex.value = 0;
  getStyleImageList()
  onClickStyleImage(imgList.value[selectedStyleImageIndex.value], selectedStyleImageIndex.value)
  GoTop()
}
const onClickStyleImage = (res, index) => {
  if ((fileModel.value?.status == uploadStatus?.handle || fileModel.value?.status == uploadStatus?.lodingImg) && !fileModel.value?.enhanceUrl) {
    return;
  }
  if (isGo.value) {
    selectedStyleImageIndex.value = index;
  } else {
    indexs3.value = index
  }
  if (fileModel.value?.enhanceUrl && !isGo.value) {
    typeModal.value = 3
    funcVisible.value = true;
    return;
  }
  selectedStyleImageIndex.value = index;
  selectSrc.value = res.src;
  selectParams.value.enhanceCfgIds = [];
  selectParams.value.enhanceCfgIds.push(res.api);
  if (res.api == 77 || res.api == 78) {
    selectParams.value.stylePath = res.style;
    selectParams.value.styleIndex = res.value;
    selectParams.value.gender = res.gender;
  } else if (res.api == 79) {
    selectParams.value.stylePath = res.style;
    selectParams.value.styleIndex = res.value;
    if (selectedImageIndex.value == 1) {
      selectParams.value.gender = 0;
    } else if (selectedImageIndex.value == 0) {
      selectParams.value.gender = 1;
    } else {
      selectParams.value.gender = selectedImageIndex.value;
    }
  } else if (res.api == 81) {
    selectParams.value.stylePath = res.value;
  } else {
    selectParams.value.stylePath = res.value;
  }
  loadImage(selectSrc.value);
}

function getStyleImageList() {
  if (genders.value == 0 && selectedStyleIndex.value == 1) {
    imgList.value = imgListPortraitFemale.value;
  } else if (genders.value == 1 && selectedStyleIndex.value == 1) {
    imgList.value = imgListPortraitMan.value;
  } else if (genders.value == 2 && selectedStyleIndex.value == 1) {
    const res = imgListPortraitFemale.value.concat(imgListPortraitMan.value)
    imgList.value = res
  } else if (genders.value == 0 && selectedStyleIndex.value == 2) {
    const res = imgListStylizedFemale.value
    imgList.value = res
  } else if (genders.value == 1 && selectedStyleIndex.value == 2) {
    const res = imgListStylizedMan.value
    imgList.value = res
  } else if (genders.value == 2 && selectedStyleIndex.value == 2) {
    const res = imgListStylizedFemale.value.concat(imgListStylizedMan.value)
    imgList.value = res
  } else if (genders.value == 0 && selectedStyleIndex.value == 0) {
    const res = imgListArtisticFemale.value
    imgList.value = res
  } else if (genders.value == 1 && selectedStyleIndex.value == 0) {
    const res = imgListArtisticMan.value
    imgList.value = res
  } else if (genders.value == 2 && selectedStyleIndex.value == 0) {
    const res = imgListArtisticFemale.value.concat(imgListArtisticMan.value)
    imgList.value = res
  } else if (genders.value == 0 && selectedStyleIndex.value == 3) {
    imgList.value = imgListFigure.value
  } else if (genders.value == 1 && selectedStyleIndex.value == 3) {
    imgList.value = imgListFigure.value
  } else if (genders.value == 2 && selectedStyleIndex.value == 3) {
    imgList.value = imgListFigure.value
  }
  selectSrc.value = imgList.value[0].src;
}
const isScroll = ref(false)
const scrollToTarget = (hash) => {
  if (!refScroll.value) return
  const anchor = document.getElementById(hash)
  if (!anchor) return
  const containerRect = refScroll.value.getBoundingClientRect()
  const anchorRect = anchor.getBoundingClientRect()
  const scrollPosition = anchorRect.top - containerRect.top + refScroll.value.scrollTop - 120

  // 执行滚动
  refScroll.value.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  })
};
function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}
const lastScrollTop = ref(0)
const onScroll = debounce((event) => {
  const currentScrollTop = event.target.scrollTop;
  if (currentScrollTop > lastScrollTop.value) {
    isScroll.value = true
  } else if (currentScrollTop < lastScrollTop.value) {
    isScroll.value = true
  }
  lastScrollTop.value = currentScrollTop;
}, 100); // 100ms 防抖
const refScroll = ref(null)
onMounted(() => {
  if (route.query.id) {
    if (route.query.id == 'hf') {
      genders.value = 0;
      selectedImageIndex.value = 0;
      selectedStyleIndex.value = 1;
      selectedStyleImageIndex.value = 10;
      getStyleImageList()
      nextTick(() => {
        scrollToTarget('img-10')
      })
    }
    if (route.query.id == 'dhsh') {
      genders.value = 0;
      selectedImageIndex.value = 0;
      selectedStyleIndex.value = 1;
      selectedStyleImageIndex.value = 0;
      getStyleImageList()
      nextTick(() => {
        scrollToTarget('img-0')
      });
    }
    if (route.query.id == 'doll') {
      genders.value = 0;
      selectedImageIndex.value = 0;
      selectedStyleIndex.value = 2;
      selectedStyleImageIndex.value = 7;
      getStyleImageList()
      nextTick(() => {
        scrollToTarget('img-69')
      });
    }
    if (route.query.id == 'ova') {
      genders.value = 0;
      selectedImageIndex.value = 0;
      selectedStyleIndex.value = 2;
      selectedStyleImageIndex.value = 14;
      getStyleImageList()
      nextTick(() => {
        scrollToTarget('img-76')
      });
    }
    if (route.query.id == 'ljgc') {
      genders.value = 1;
      selectedImageIndex.value = 1;
      selectedStyleIndex.value = 1;
      selectedStyleImageIndex.value = 4;
      getStyleImageList()
      nextTick(() => {

        scrollToTarget('img-32')
      });
    }
    if (route.query.id == 'repin') {
      genders.value = 0;
      selectedImageIndex.value = 0;
      selectedStyleIndex.value = 2;
      selectedStyleImageIndex.value = 12;
      getStyleImageList()
      nextTick(() => {

        scrollToTarget('img-74')
      });
    }
    if (route.query.id == 'manga') {
      genders.value = 0;
      selectedImageIndex.value = 0;
      selectedStyleIndex.value = 2;
      selectedStyleImageIndex.value = 15;
      getStyleImageList()
      nextTick(() => {
        scrollToTarget('img-77')
      });
    }
    if (route.query.id == 'egypt') {
      genders.value = 1;
      selectedImageIndex.value = 1;
      selectedStyleIndex.value = 0;
      selectedStyleImageIndex.value = 2;
      getStyleImageList()
      nextTick(() => {
        scrollToTarget('img-110')
      });
    }
    selectSrc.value = imgList.value[selectedStyleImageIndex.value].src;
    onClickStyleImage(imgList.value[selectedStyleImageIndex.value], selectedStyleImageIndex.value)
  } else {
    imgList.value = imgListArtisticFemale.value;
    onClickStyleImage(imgList.value[selectedStyleImageIndex.value], selectedStyleImageIndex.value)
    selectSrc.value = imgList.value[0].src;
    loadImage(selectSrc.value);
  }
})

function onEvaluate() {
  const fileList = [...props.fileList];
  fileList[0].isEvaluate = true;
  updateFileListEvent(fileList)
}
function onApply() {
  useLogEvent({ eventName: "apply-ai_portrait_generator" });
  if (isLogin.value) {
    if (fileModel.value?.status == uploadStatus.success) {
      return;
    }
    applyEvent(selectParams.value);
    isGo.value = false
  } else {
    mainStore.setVisibleLogin(true);
  }
}
watch(
  () => props.fileList,
  () => {
    console.log("数据fileList:", props.fileList);
    if (props.fileList.length) {
      fileModel.value = props.fileList[0];
    } else {
      fileModel.value = null;
    }
  },
  { deep: true }
);
const funcVisible = ref(false);
function switchHandleCancel() {
  funcVisible.value = false;
}
const isGo = ref(false)
function switchHandleOk() {
  isGo.value = true
  fileModel.value = {}
  downloadUrlEvent("")
  if (typeModal.value == 1) {
    onClickImg(indexs.value)
  } else if (typeModal.value == 2) {
    onClickStyle(indexs2.value)
  } else {
    onClickStyleImage(imgList.value[indexs3.value], indexs3.value)
  }
  funcVisible.value = false;
}
function GoTop() {
  refScroll.value.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
const handleImageError = (item, event) => {
  if (!item.retryCount) item.retryCount = 0;
  if (item.retryCount < 5) {
    item.retryCount++;
    // 添加固定参数名（避免被服务端拦截）
    event.target.src = `${item.src}${item.src.includes('?') ? '&' : '?'}_retry=${item.retryCount}`;
  }
};


const isLoaded = ref(false)

// 加载图片的函数
const loadImage = (src) => {
  isLoaded.value = false
  const img = new Image()
  img.src = src
  img.onload = () => {
    isLoaded.value = true
  }
  img.onerror = () => {
    console.error('图片加载失败')
  }
}

// 监听图片源变化
watch(() => props.selectSrc, (newSrc) => {
  if (newSrc) {
    loadImage(newSrc)
  }
})
</script>
<style scoped>
.selected {
  border: 2px solid transparent;
  box-shadow: -1px -1px 0 1px #5F45FF, 1px 1px 0 1px #C02CFF;
  background: #5F45FF14;
  border-radius: 20px;
}

.imgSelected {
  border: 2px solid transparent;
  box-shadow: 0 0 0 2px #5F45FF;
  border-radius: 10px;
  width: 93px;
  height: 138px;
}

.scrollbar-x {
  overflow-y: overlay;
  scrollbar-gutter: stable;
}

.h-screen-minus-80 {
  height: calc(100vh - 80px);
}

.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.your-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  /* 视窗宽度（忽略滚动条） */
  height: 1px;
  background: #ccc;
}

.custom-scrollbar {
  scroll-margin-top: 100px;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #5F45FF;
  border-top: 4px solid #5F45FF66;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* @keyframes fadeInOut {
  0% {
    opacity: 0.2;
  }

  50% {
    opacity: 0.8;
  }

  100% {
    opacity: 1;
  }
}

.img-container {
  animation: fadeInOut 0.7s ease-in-out;
} */
</style>
